import { connect } from 'react-redux';
import { Box, Grid, Paper, Typography } from '@mui/material';
import darkBarcode from '../../assets/images/darkbarcode.png';
import lightBarcode from '../../assets/images/Bar_code_scan.png';
import styles from './PlatePunching.module.scss';

import { useMessageContextManager } from '../../components/MessageOverlay/MessageOverlay';
import {
	DARK_MODE,
	PART_VALIDATION_ERROR,
	PART_VALIDATION_LOADING,
} from '../../constants';
import { useRedirectToNextScreen } from '../../hooks';
import { ScanOrEnterBarcodeForm } from '../../components';
import { receivePart } from '../../redux/actionCreators/receivePart';

const classNames = {
	paper: {
		height: '100%',
		display: 'flex',
	},
	tableContentContainer: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		padding: '30px',
		backgroundColor: 'background.default',
		boxShadow: '0px 3px 6px #00000027',
		borderRadius: '5px',
	},
	textInputContainer: {
		width: { sm: '100%', md: '80%' },
	},
};

const mapStateToProps = (state) => {
	return {
		themeMode: state.theme.themeMode,
	};
};

const mapDispatchToProps = (dispatch) => ({
	receivePart: (serialNumber, successCallback, errorCallback) =>
		dispatch(receivePart(serialNumber, successCallback, errorCallback)),
});

export const PlatePunching = ({ receivePart, themeMode }) => {
	const { showMessageOverlay } = useMessageContextManager();

	const redirect = useRedirectToNextScreen();

	const scanSerialNumber = (serialNumber, resetBarcodeValue) => {
		const updatedScannedValue = serialNumber.substring(0, 17);
		const closeMesssageOverlay = showMessageOverlay({
			contextText: PART_VALIDATION_LOADING.SERIAL_NUMBER_ERROR_CONTEXT_TEXT,
			loading: true,
		});

		receivePart(
			updatedScannedValue,
			() => {
				closeMesssageOverlay();
				redirect(() => null, {
					paramId: 'start',
					useSameOperation: true,
				});
			},
			(error) => {
				resetBarcodeValue();
				showMessageOverlay({
					contextText:
						PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Scanning Serial Number',
					info: error?.response?.data?.message,
					error: true,
				});
				// logError(`Receive part and plate punching flow ${error}`);
			},
		);
	};

	return (
		<Paper sx={classNames.tableContentContainer}>
			<Grid container>
				<Typography
					variant="h6"
					sx={{ color: (theme) => theme.palette.text.primary }}
				>
					Check Part Status
				</Typography>
			</Grid>
			<Grid
				container
				direction="column"
				margin="auto"
				columnSpacing={2}
				mt={6}
				sx={{
					flexGrow: 1,
					width: '60%',
					verticalAlign: 'center',
					justifyContent: 'center',
				}}
			>
				<Grid item container alignItems="center" justifyContent="center">
					<Typography variant="h3" sx={{ color: '#27C8F7' }}>
						SCAN SERIAL NO. / VIN
					</Typography>
					<Box
						item
						sx={{
							height: { sm: 52, md: 56, lg: 70 },
							width: { sm: 90, md: 120, lg: 140 },
						}}
					>
					<img
						src={themeMode === DARK_MODE ? darkBarcode : lightBarcode}
						alt=""
						className={styles.barcodeImage}
					/>
					</Box>
				</Grid>
				<Grid
					item
					container
					justifyContent="center"
					alignItems="center"
					padding={2}
					paddingBottom={22}
				>
					<Box sx={classNames.textInputContainer}>
						<ScanOrEnterBarcodeForm
							enableAutoEnter
							isAlphaNumericValidation={false}
							onSubmit={scanSerialNumber}
						/>
					</Box>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default connect(mapStateToProps, mapDispatchToProps)(PlatePunching);
